<template>
    <div class="modal is-active folder-modal">
        <div class="modal-background" />
        <div class="modal-content">
            <div class="box">
                <div class="logo-app px-6 mx-4 pb-4">
                    <img
                        :src="require('@/assets/images/logo_eduloc360_red.png')"
                        class="mt-4"
                    />
                </div>

                <div class="px-6 mx-6 pb-5">
                    <img
                        :src="require('@/assets/images/folder.png')"
                        class="mt-4"
                    />
                </div>

                <p class="is-size-5 has-text-centered">
                    {{ $t('Dashboard.create_folder_title') }}
                </p>
                <p class="is-size-6 has-text-centered secondary-font pb-4">
                    {{ $t('Dashboard.create_folder_subtitle') }}
                </p>
                <div class="field">
                    <p class="control">
                        <input
                            v-model="title"
                            :placeholder="$t('Dashboard.create_folder_name')"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
                <div class="level py-4">
                    <div class="level-left">
                        <button
                            class="level-item button is-right has-background-grey-light has-text-black"
                            @click="$emit('cancel')"
                        >
                            {{ $t('Buttons.cancel') }}
                        </button>
                    </div>
                    <div class="level-right">
                        <button
                            class="level-item button is-left has-background-eduloc-green has-text-white"
                            @click="createFolder"
                        >
                            {{ $t('Buttons.save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    components: {},
    props: {
        project: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            title: '',
        };
    },
    computed: {},
    mounted() {},
    methods: {
        async createFolder() {
            if (this.title.length) {
                this.$emit('create', this.title);
            }
        },
    },
};
</script>

<style scooped>
    .folder-modal .box{
        padding: 35px;
    }
    .folder-modal .modal-background{
        background-color: rgba(0, 0, 0, 0.8);
    }
    .folder-modal .modal-content .box,.folder-modal .modal-content{
        box-shadow: none;
    }
</style>
